export { SpanHeadingS } from './CustomerReview';
